import { render, staticRenderFns } from "./floating-panel.vue?vue&type=template&id=7064540e&scoped=true"
import script from "./floating-panel.vue?vue&type=script&lang=js"
export * from "./floating-panel.vue?vue&type=script&lang=js"
import style0 from "./floating-panel.vue?vue&type=style&index=0&id=7064540e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7064540e",
  null
  
)

export default component.exports